// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_DEPARTMENT, DELETE_DEPARTMENT, DEPARTMENT, EDIT_DEPARTMENT, GET_DEPARTMENT } from '../../../../common/constant'

export const actionDepartment = createAsyncThunk('appDepartment/actionDepartment', async (params, thunkAPI) => {
    return await post(DEPARTMENT, params, thunkAPI)
})

export const actionAddDepartment = createAsyncThunk('appDepartment/actionAddDepartment', async (params, thunkAPI) => {
    return await put(ADD_DEPARTMENT, params, thunkAPI)
})

export const actionGetDepartment = createAsyncThunk('appDepartment/actionGetDepartment', async (params, thunkAPI) => {
    return await post(GET_DEPARTMENT, params, thunkAPI)
})

export const actionEditDepartment = createAsyncThunk('appDepartment/actionEditDepartment', async (params, thunkAPI) => {
    return await post(EDIT_DEPARTMENT, params, thunkAPI)
})

export const actionDeleteDepartment = createAsyncThunk('appDepartment/actionDeleteDepartment', async (params, thunkAPI) => {
    return await post(DELETE_DEPARTMENT, params, thunkAPI)
})

export const appDepartmentSlice = createSlice({
    name: 'appDepartment',
    initialState: {
        //list
        loading: false,
        department: null,

        //add
        loadingAdd: false,
        addDepartment: null,

        //get
        loadingGet: false,
        getDepartment: null,

        //edit
        loadingEdit: false,
        editDepartment: null,

        //delete
        loadingDelete: false,
        deleteDepartment: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetDepartmentResponse: (state) => {
            state.department = null
        },
        resetAddDepartmentResponse: (state) => {
            state.addDepartment = null
        },
        resetGetDepartmentResponse: (state) => {
            state.getDepartment = null
        },
        resetEditDepartmentResponse: (state) => {
            state.editDepartment = null
        },
        resetDeleteDepartmentResponse: (state) => {
            state.deleteDepartment = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionDepartment.pending, (state) => {
                state.loading = true
            })
            .addCase(actionDepartment.fulfilled, (state, action) => {
                state.loading = false
                state.department = action.payload
            })
            .addCase(actionDepartment.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddDepartment.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddDepartment.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addDepartment = action.payload
            })
            .addCase(actionAddDepartment.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetDepartment.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetDepartment.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getDepartment = action.payload
            })
            .addCase(actionGetDepartment.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditDepartment.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditDepartment.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editDepartment = action.payload
            })
            .addCase(actionEditDepartment.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteDepartment.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteDepartment.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteDepartment = action.payload
            })
            .addCase(actionDeleteDepartment.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetDepartmentResponse, resetAddDepartmentResponse, resetGetDepartmentResponse, resetEditDepartmentResponse, resetDeleteDepartmentResponse } = appDepartmentSlice.actions

export default appDepartmentSlice.reducer